function sha256(plain: string): Promise<ArrayBuffer> {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest('SHA-256', data);
}

function base64urlencode(a: ArrayBuffer) {
    let str = '';
    const bytes = new Uint8Array(a);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        str += String.fromCharCode(bytes[i]);
    }
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

async function generateCodeChallenge(verifier: string) {
    const hashed = await sha256(verifier);
    return base64urlencode(hashed);
}

function generateCodeVerifier() {
    const random = new Uint8Array(32);
    window.crypto.getRandomValues(random);
    return base64urlencode(random);
}

export { generateCodeChallenge, generateCodeVerifier };
